/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, input, OnDestroy, OnInit } from '@angular/core';
import { ITEM } from '@utils/constants';
@Component({
  selector: 'app-countdown',
  standalone: true,
  imports: [],
  templateUrl: './countdown.component.html',
  styleUrl: './countdown.component.scss'
})
export class CountdownComponent implements OnInit, OnDestroy {
  endDate = input<string>();

  days: number = ITEM.START_INDEX;
  hours: number = ITEM.START_INDEX;
  minutes: number = ITEM.START_INDEX;
  seconds: number = ITEM.START_INDEX;
  
  private timer: any;
  private targetDate: number = ITEM.START_INDEX;


  ngOnInit() { 
    this.targetDate = new Date(this.endDate() ?? '').getTime();

    const MILLISECONDS_IN_A_SECOND = 1000;
    const SECONDS_IN_A_MINUTE = 60;
    const MINUTES_IN_AN_HOUR = 60;
    const HOURS_IN_A_DAY = 24;

    this.timer = setInterval(() => {
      const now = Date.now();
      const distance = this.targetDate - now;

      this.days = Math.floor(distance / (MILLISECONDS_IN_A_SECOND * SECONDS_IN_A_MINUTE * MINUTES_IN_AN_HOUR * HOURS_IN_A_DAY));
      this.hours = Math.floor((distance % (MILLISECONDS_IN_A_SECOND * SECONDS_IN_A_MINUTE * MINUTES_IN_AN_HOUR * HOURS_IN_A_DAY)) / (MILLISECONDS_IN_A_SECOND * SECONDS_IN_A_MINUTE * MINUTES_IN_AN_HOUR));
      this.minutes = Math.floor((distance % (MILLISECONDS_IN_A_SECOND * SECONDS_IN_A_MINUTE * MINUTES_IN_AN_HOUR)) / (MILLISECONDS_IN_A_SECOND * SECONDS_IN_A_MINUTE));
      this.seconds = Math.floor((distance % (MILLISECONDS_IN_A_SECOND * SECONDS_IN_A_MINUTE)) / MILLISECONDS_IN_A_SECOND);

      if (distance < ITEM.START_INDEX) {
        clearInterval(this.timer);  
        this.days = this.hours = this.minutes = this.seconds = 0;
      }
    }, MILLISECONDS_IN_A_SECOND);
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
